export default __webpack_public_path__ + "static/media/motorcycle_dark.885271ed.png";